/* Project Cody — theme interactions
   Header scroll state, full-screen menu, reveal/bloom observer,
   product-page size/framing picker, gallery, AJAX add-to-cart + popup.
   Idempotent: safe on load and on Shopify section re-render. */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }
  function money(cents, currency) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------- Header scroll state ---------- */
  function initHeader() {
    var header = document.querySelector('[data-cody-header]');
    if (!header || header.dataset.codyBound) return;
    header.dataset.codyBound = '1';
    // Pages without a hero (product, etc.) have a light background — keep the
    // header in its solid/dark state always so the logo + menu stay visible.
    if (!document.querySelector('.cody-hero')) { header.classList.add('is-scrolled'); return; }
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Full-screen menu ---------- */
  function initMenu() {
    var openBtn = document.querySelector('[data-cody-menu-open]');
    var overlay = document.querySelector('[data-cody-menu]');
    if (!openBtn || !overlay || openBtn.dataset.codyBound) return;
    openBtn.dataset.codyBound = '1';
    var open = function () { overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false'); openBtn.setAttribute('aria-expanded', 'true'); };
    var close = function () { overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true'); openBtn.setAttribute('aria-expanded', 'false'); };
    openBtn.addEventListener('click', open);
    overlay.querySelectorAll('[data-cody-menu-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) close(); });
  }

  /* ---------- Header cart count ---------- */
  function setCartCount(n) {
    document.querySelectorAll('[data-cody-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  function initCart() {
    if (document.documentElement.dataset.codyCartInit) return;
    document.documentElement.dataset.codyCartInit = '1';
    // Refresh the count from the live cart (page HTML can be cached / stale).
    fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () {});
  }

  /* ---------- Cart notification popup ---------- */
  var cartNote = null;
  function initCartNote() {
    var el = document.querySelector('[data-cody-cartnote]');
    if (!el || el.dataset.codyBound) { cartNote = cartNote || el; return; }
    el.dataset.codyBound = '1';
    cartNote = el;
    el.querySelectorAll('[data-cody-cartnote-close]').forEach(function (b) {
      b.addEventListener('click', function () { hideCartNote(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideCartNote(); });
  }
  function hideCartNote() {
    if (!cartNote) return;
    cartNote.classList.remove('is-open');
    cartNote.setAttribute('aria-hidden', 'true');
  }
  function showCartNote(info, cart) {
    if (!cartNote) return;
    var q = function (s) { return cartNote.querySelector(s); };
    if (q('[data-cody-note-img]')) { q('[data-cody-note-img]').src = info.image || ''; q('[data-cody-note-img]').alt = info.name || ''; }
    if (q('[data-cody-note-name]')) q('[data-cody-note-name]').textContent = info.name || '';
    if (q('[data-cody-note-variant]')) q('[data-cody-note-variant]').textContent = info.variantLabel || '';
    if (q('[data-cody-note-price]')) q('[data-cody-note-price]').textContent = info.price || '';
    if (q('[data-cody-note-total]')) q('[data-cody-note-total]').textContent = money(cart.total_price, cart.currency);
    if (q('[data-cody-note-count]')) q('[data-cody-note-count]').textContent = cart.item_count;
    cartNote.classList.add('is-open');
    cartNote.setAttribute('aria-hidden', 'false');
  }

  /* ---------- Product page: picker + gallery + add to cart ---------- */
  function initProduct() {
    var scope = document.querySelector('[data-cody-product]');
    if (!scope || scope.dataset.codyBound) return;
    scope.dataset.codyBound = '1';

    /* Gallery thumbs */
    var main = scope.querySelector('[data-cody-main]');
    var mainDefault = main ? (main.getAttribute('src') || '') : '';
    function setMainImage(url) {
      if (!main || !url || main.getAttribute('src') === url) return;
      /* main img has a srcset — must clear it or the browser ignores the new src */
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = url;
    }
    var thumbs = Array.prototype.slice.call(scope.querySelectorAll('[data-cody-thumb]'));
    var curImg = 0;
    function activateThumb(i) {
      if (i < 0) i = thumbs.length - 1;
      if (i >= thumbs.length) i = 0;
      curImg = i;
      var t = thumbs[i];
      if (!t) return;
      setMainImage(t.dataset.full);
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { activateThumb(i); });
    });

    /* Mobile: swipe the main image to move to the next / previous photo */
    if (main && thumbs.length > 1) {
      var sx = 0, sy = 0, swiping = false;
      main.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; swiping = true;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (!swiping) return; swiping = false;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          activateThumb(curImg + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    }

    /* Variant data */
    var dataEl = scope.querySelector('[data-cody-variants]');
    var variants = [];
    var dims = {};
    if (dataEl) {
      try { variants = JSON.parse(dataEl.dataset.codyVariants || '[]'); } catch (e) { variants = []; }
      dims = { small: dataEl.dataset.dimSmall || '', medium: dataEl.dataset.dimMedium || '', large: dataEl.dataset.dimLarge || '' };
    }
    var hasVariantImages = variants.some(function (v) { return v && v.img; });

    var sizeBlock = scope.querySelector('[data-cody-size-block]');
    var sizeRow = scope.querySelector('[data-cody-size-row]');
    var frameBlock = scope.querySelector('[data-cody-frame-block]');
    var frameRow = scope.querySelector('[data-cody-frame-row]');
    var priceEl = scope.querySelector('[data-cody-price]');
    var dimValueEl = scope.querySelector('[data-cody-dim-value]');
    var addBtn = scope.querySelector('[data-cody-add]');
    var addDefault = addBtn ? addBtn.textContent : 'Add to cart';
    var productName = (scope.querySelector('.cody-product__name') || {}).textContent || '';
    var sel = { size: null, framing: null };

    function uniq(a) { var o = []; a.forEach(function (v) { if (o.indexOf(v) === -1) o.push(v); }); return o; }
    function sizeValues() { return uniq(variants.map(function (v) { return v.size; }).filter(Boolean)); }
    function minCents(pred) { var c = variants.filter(pred).map(function (v) { return v.cents; }); return c.length ? Math.min.apply(null, c) : Infinity; }
    function frameValues() {
      var vals = uniq(variants.map(function (v) { return v.framing; }).filter(Boolean));
      vals.sort(function (a, b) { return minCents(function (v) { return v.framing === a; }) - minCents(function (v) { return v.framing === b; }); });
      return vals;
    }
    function anyAvail(pred) { return variants.some(function (v) { return pred(v) && v.available; }); }
    function match() { return variants.filter(function (v) { return v.size === sel.size && (frameValues().length ? v.framing === sel.framing : true); })[0] || null; }
    function firstFrameFor(s) { var v = variants.filter(function (x) { return x.size === s && x.available; })[0] || variants.filter(function (x) { return x.size === s; })[0]; return v ? v.framing : null; }

    function frameSwatch(name) {
      var n = (name || '').toLowerCase();
      var color = '';
      if (n.indexOf('black') > -1) color = '#20201e';
      else if (n.indexOf('oak') > -1) color = '#c69a63';
      else if (n.indexOf('white') > -1) color = '#f4f2ec';
      if (!color) return '';
      return '<span class="cody-pick__sw" style="background:' + color + '"></span>';
    }

    function makeBtn(label, sub, pressed, disabled) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cody-pick__btn';
      b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      if (disabled) b.disabled = true;
      b.innerHTML = sub ? (label + '<small>' + sub + '</small>') : label;
      return b;
    }

    function render() {
      if (!variants.length) { if (sizeBlock) sizeBlock.hidden = true; if (frameBlock) frameBlock.hidden = true; return; }
      var sizes = sizeValues(), frames = frameValues();
      if (sizeRow) {
        sizeRow.innerHTML = '';
        if (sizes.length) {
          sizeBlock.hidden = false;
          sizes.forEach(function (s) {
            var sub = dims[s.toLowerCase()] || '';
            var b = makeBtn(s, sub, s === sel.size, !anyAvail(function (v) { return v.size === s; }));
            b.addEventListener('click', function () { sel.size = s; if (!variants.filter(function (v) { return v.framing === sel.framing && v.size === s; })[0]) sel.framing = firstFrameFor(s); update(); });
            sizeRow.appendChild(b);
          });
        } else { sizeBlock.hidden = true; }
      }
      if (frameRow) {
        frameRow.innerHTML = '';
        if (frames.length) {
          frameBlock.hidden = false;
          frames.forEach(function (f) {
            var b = makeBtn(f, '', f === sel.framing, !anyAvail(function (v) { return v.framing === f && v.size === sel.size; }));
            var sw = frameSwatch(f);
            if (sw) { b.classList.add('has-sw'); b.innerHTML = sw + '<span>' + f + '</span>'; }
            b.addEventListener('click', function () { sel.framing = f; update(); });
            frameRow.appendChild(b);
          });
        } else { frameBlock.hidden = true; }
      }
    }

    function update() {
      render();
      if (dimValueEl && sel.size) { var d = dims[sel.size.toLowerCase()]; if (d) dimValueEl.textContent = d; }
      var v = match();
      /* Swap the main photo to the selected frame's image (only once Cody has assigned framed images to variants) */
      if (hasVariantImages) { setMainImage(v && v.img ? v.img : mainDefault); }
      if (v) {
        if (priceEl) priceEl.textContent = v.price;
        if (v.available) { addBtn.disabled = false; addBtn.textContent = addDefault; addBtn.dataset.variant = v.id; }
        else { addBtn.disabled = true; addBtn.textContent = 'Sold out'; addBtn.dataset.variant = ''; }
      } else {
        addBtn.disabled = true; addBtn.textContent = variants.length ? 'Unavailable' : 'Coming soon'; addBtn.dataset.variant = '';
      }
    }

    /* default selection = cheapest (prefer available) */
    var pool = variants.filter(function (v) { return v.available; });
    if (!pool.length) pool = variants.slice();
    pool.sort(function (a, b) { return a.cents - b.cents; });
    if (pool[0]) { sel.size = pool[0].size; sel.framing = pool[0].framing; }
    update();

    /* Add to cart */
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = addBtn.dataset.variant;
        if (!variantId) return;
        var v = match();
        addBtn.disabled = true;
        var orig = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            addBtn.disabled = false; addBtn.textContent = orig;
            setCartCount(cart.item_count);
            showCartNote({
              name: productName,
              variantLabel: [sel.size, sel.framing].filter(Boolean).join(' · '),
              price: v ? v.price : '',
              image: main ? main.currentSrc || main.src : ''
            }, cart);
          })
          .catch(function () { addBtn.disabled = false; addBtn.textContent = orig; alert('Sorry — could not add to cart. Please try again.'); });
      });
    }
  }

  /* ---------- Social icons (Instagram slide-out) ---------- */
  function initSocials() {
    document.querySelectorAll('[data-cody-ig-toggle]:not([data-cody-bound])').forEach(function (t) {
      t.setAttribute('data-cody-bound', '1');
      var group = t.closest('[data-cody-ig]');
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var open = group.classList.toggle('is-open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    if (!document.documentElement.dataset.codySocialsDoc) {
      document.documentElement.dataset.codySocialsDoc = '1';
      var closeAll = function (e) {
        document.querySelectorAll('[data-cody-ig].is-open').forEach(function (g) {
          if (!e || !g.contains(e.target)) {
            g.classList.remove('is-open');
            var b = g.querySelector('[data-cody-ig-toggle]');
            if (b) b.setAttribute('aria-expanded', 'false');
          }
        });
      };
      document.addEventListener('click', closeAll);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
    }
  }

  /* ---------- Reveal + bloom ---------- */
  function initReveal() {
    var targets = document.querySelectorAll('[data-cody-reveal]:not([data-cody-observed]),[data-cody-bloom]:not([data-cody-observed])');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      targets.forEach(function (el) { el.setAttribute('data-cody-observed', '1'); el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target; obs.unobserve(el);
        var start = function () { el.classList.add('is-visible'); el.style.willChange = 'transform, opacity'; setTimeout(function () { el.style.willChange = ''; }, 1300); };
        if (el.hasAttribute('data-cody-reveal') && el.decode) { el.decode().then(start).catch(start); } else { start(); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    targets.forEach(function (el) { el.setAttribute('data-cody-observed', '1'); io.observe(el); });
  }

  function initAll() { initHeader(); initMenu(); initCart(); initCartNote(); initProduct(); initSocials(); initReveal(); }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); }
  else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();
